import { render } from "./Support.vue?vue&type=template&id=9cdae1a2&ts=true"
import script from "./Support.vue?vue&type=script&lang=ts"
export * from "./Support.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__